module.exports = __webpack_public_path__ + "static/media/section_2_2_B.f639923c.png";